module["exports"] = [
  "BV",
  "V.O.F.",
  "Groep",
  "NV",
  "Bedrijf", 
  "en Zonen",
  "Combinatie"
];
